import { render, staticRenderFns } from "./D24.vue?vue&type=template&id=73c0d360&scoped=true"
import script from "./D24.vue?vue&type=script&lang=js"
export * from "./D24.vue?vue&type=script&lang=js"
import style0 from "./D24.vue?vue&type=style&index=0&id=73c0d360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0d360",
  null
  
)

export default component.exports